module.exports = __webpack_public_path__ + "images/category_lp/farm_machine/store_images/4@2x_e0b70b602145b35c268e3877f850d034.png";